var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3047_7418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.499h-9a.75.75 0 0 1-.75-.75zm9.75 3.749h-9a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5zm0 4.5H16.5a.75.75 0 0 0 0 1.5h6.75a.75.75 0 0 0 0-1.5zm-9.216 2.062a.742.742 0 0 1-.534.91l-.188.028a.76.76 0 0 1-.73-.563 5.25 5.25 0 0 0-10.163 0 .75.75 0 0 1-.92.535.742.742 0 0 1-.533-.91 6.75 6.75 0 0 1 3.806-4.49 4.5 4.5 0 1 1 5.456 0 6.75 6.75 0 0 1 3.806 4.49zM7.5 12.75a3 3 0 1 0-3-3 3.01 3.01 0 0 0 3 3z",
    fill: "#696871"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3047_7418"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTitle);
export default __webpack_public_path__ + "static/media/profileTitle.7d72053febde5f9491666cbc69b7d588.svg";
export { ForwardRef as ReactComponent };